export default [
  {name: "Afganistán", code: "af"},
  {name: "Åland", code: "ax"},
  {name: "Albania", code: "al"},
  {name: "Alemania", code: "de"},
  {name: "Andorra", code: "ad"},
  {name: "Angola", code: "ao"},
  {name: "Anguila", code: "ai"},
  {name: "Antártida", code: "aq"},
  {name: "Antigua y Barbuda", code: "ag"},
  {name: "Arabia Saudita", code: "sa"},
  {name: "Argelia", code: "dz"},
  {name: "Argentina", code: "ar"},
  {name: "Armenia", code: "am"},
  {name: "Aruba", code: "aw"},
  {name: "Australia", code: "au"},
  {name: "Austria", code: "at"},
  {name: "Azerbaiyán", code: "az"},
  {name: "Bahamas", code: "bs"},
  {name: "Bangladés", code: "bd"},
  {name: "Barbados", code: "bb"},
  {name: "Baréin", code: "bh"},
  {name: "Bélgica", code: "be"},
  {name: "Belice", code: "bz"},
  {name: "Benín", code: "bj"},
  {name: "Bermudas", code: "bm"},
  {name: "Bielorrusia", code: "by"},
  {name: "Bolivia", code: "bo"},
  {name: "Bosnia y Herzegovina", code: "ba"},
  {name: "Botsuana", code: "bw"},
  {name: "Brasil", code: "br"},
  {name: "Brunéi", code: "bn"},
  {name: "Bulgaria", code: "bg"},
  {name: "Burkina Faso", code: "bf"},
  {name: "Burundi", code: "bi"},
  {name: "Bután", code: "bt"},
  {name: "Cabo Verde", code: "cv"},
  {name: "Camboya", code: "kh"},
  {name: "Camerún", code: "cm"},
  {name: "Canadá", code: "ca"},
  {name: "Catar", code: "qa"},
  {name: "Chad", code: "td"},
  {name: "Chile", code: "cl"},
  {name: "China", code: "cn"},
  {name: "Chipre", code: "cy"},
  {name: "Colombia", code: "co"},
  {name: "Comoras", code: "km"},
  {name: "Corea del Norte", code: "kp"},
  {name: "Corea del Sur", code: "kr"},
  {name: "Costa de Marfil", code: "ci"},
  {name: "Costa Rica", code: "cr"},
  {name: "Croacia", code: "hr"},
  {name: "Cuba", code: "cu"},
  {name: "Curazao", code: "cw"},
  {name: "Dinamarca", code: "dk"},
  {name: "Dominica", code: "dm"},
  {name: "Ecuador", code: "ec"},
  {name: "Egipto", code: "eg"},
  {name: "El Salvador", code: "sv"},
  {name: "Eritrea", code: "er"},
  {name: "Eslovaquia", code: "sk"},
  {name: "Eslovenia", code: "si"},
  {name: "España", code: "es"},
  {name: "Estados Unidos", code: "us"},
  {name: "Estonia", code: "ee"},
  {name: "Etiopía", code: "et"},
  {name: "Filipinas", code: "ph"},
  {name: "Finlandia", code: "fi"},
  {name: "Fiyi", code: "fj"},
  {name: "Francia", code: "fr"},
  {name: "Gabón", code: "ga"},
  {name: "Gambia", code: "gm"},
  {name: "Georgia", code: "ge"},
  {name: "Ghana", code: "gh"},
  {name: "Gibraltar", code: "gi"},
  {name: "Granada", code: "gd"},
  {name: "Grecia", code: "gr"},
  {name: "Groenlandia", code: "gl"},
  {name: "Guadalupe", code: "gp"},
  {name: "Guam", code: "gu"},
  {name: "Guatemala", code: "gt"},
  {name: "Guayana Francesa", code: "gf"},
  {name: "Guernsey", code: "gg"},
  {name: "Guinea", code: "gn"},
  {name: "Guinea-Bisáu", code: "gw"},
  {name: "Guinea Ecuatorial", code: "gq"},
  {name: "Guyana", code: "gy"},
  {name: "Haití", code: "ht"},
  {name: "Honduras", code: "hn"},
  {name: "Hong Kong", code: "hk"},
  {name: "Hungría", code: "hu"},
  {name: "India", code: "in"},
  {name: "Indonesia", code: "id"},
  {name: "Irak", code: "iq"},
  {name: "Irán", code: "ir"},
  {name: "Irlanda", code: "ie"},
  {name: "Isla Bouvet", code: "bv"},
  {name: "Isla de Man", code: "im"},
  {name: "Isla de Navidad", code: "cx"},
  {name: "Islandia", code: "is"},
  {name: "Islas Caimán", code: "ky"},
  {name: "Islas Cocos", code: "cc"},
  {name: "Islas Cook", code: "ck"},
  {name: "Islas Feroe", code: "fo"},
  {name: "Islas Malvinas", code: "fk"},
  {name: "Islas Marshall", code: "mh"},
  {name: "Islas Pitcairn", code: "pn"},
  {name: "Islas Salomón", code: "sb"},
  {name: "Israel", code: "il"},
  {name: "Italia", code: "it"},
  {name: "Jamaica", code: "jm"},
  {name: "Japón", code: "jp"},
  {name: "Jersey", code: "je"},
  {name: "Jordania", code: "jo"},
  {name: "Kazajistán", code: "kz"},
  {name: "Kenia", code: "ke"},
  {name: "Kirguistán", code: "kg"},
  {name: "Kiribati", code: "ki"},
  {name: "Kuwait", code: "kw"},
  {name: "Laos", code: "la"},
  {name: "Lesoto", code: "ls"},
  {name: "Letonia", code: "lv"},
  {name: "Líbano", code: "lb"},
  {name: "Liberia", code: "lr"},
  {name: "Libia", code: "ly"},
  {name: "Liechtenstein", code: "li"},
  {name: "Lituania", code: "lt"},
  {name: "Luxemburgo", code: "lu"},
  {name: "Macao", code: "mo"},
  {name: "Macedonia del Norte", code: "mk"},
  {name: "Madagascar", code: "mg"},
  {name: "Malasia", code: "my"},
  {name: "Malaui", code: "mw"},
  {name: "Maldivas", code: "mv"},
  {name: "Malí", code: "ml"},
  {name: "Malta", code: "mt"},
  {name: "Marruecos", code: "ma"},
  {name: "Martinica", code: "mq"},
  {name: "Mauricio", code: "mu"},
  {name: "Mauritania", code: "mr"},
  {name: "Mayotte", code: "yt"},
  {name: "México", code: "mx"},
  {name: "Micronesia", code: "fm"},
  {name: "Moldavia", code: "md"},
  {name: "Mónaco", code: "mc"},
  {name: "Mongolia", code: "mn"},
  {name: "Montenegro", code: "me"},
  {name: "Montserrat", code: "ms"},
  {name: "Mozambique", code: "mz"},
  {name: "Birmania", code: "mm"},
  {name: "Namibia", code: "na"},
  {name: "Nauru", code: "nr"},
  {name: "Nepal", code: "np"},
  {name: "Nicaragua", code: "ni"},
  {name: "Níger", code: "ne"},
  {name: "Nigeria", code: "ng"},
  {name: "Niue", code: "nu"},
  {name: "Isla Norfolk", code: "nf"},
  {name: "Noruega", code: "no"},
  {name: "Nueva Caledonia", code: "nc"},
  {name: "Nueva Zelanda", code: "nz"},
  {name: "Omán", code: "om"},
  {name: "Países Bajos", code: "nl"},
  {name: "Pakistán", code: "pk"},
  {name: "Palaos", code: "pw"},
  {name: "Palestina", code: "ps"},
  {name: "Panamá", code: "pa"},
  {name: "Papúa Nueva Guinea", code: "pg"},
  {name: "Paraguay", code: "py"},
  {name: "Perú", code: "pe"},
  {name: "Polinesia Francesa", code: "pf"},
  {name: "Polonia", code: "pl"},
  {name: "Portugal", code: "pt"},
  {name: "Puerto Rico", code: "pr"},
  {name: "Reino Unido", code: "gb"},
  {name: "República Checa", code: "cz"},
  {name: "República del Congo", code: "cg"},
  {name: "Reunión", code: "re"},
  {name: "Ruanda", code: "rw"},
  {name: "Rumania", code: "ro"},
  {name: "Rusia", code: "ru"},
  {name: "Samoa", code: "ws"},
  {name: "Samoa Americana", code: "as"},
  {name: "San Bartolomé", code: "bl"},
  {name: "San Marino", code: "sm"},
  {name: "San Martín", code: "mf"},
  {name: "Santa Lucía", code: "lc"},
  {name: "Senegal", code: "sn"},
  {name: "Serbia", code: "rs"},
  {name: "Seychelles", code: "sc"},
  {name: "Sierra Leona", code: "sl"},
  {name: "Singapur", code: "sg"},
  {name: "San Martín", code: "sx"},
  {name: "Siria", code: "sy"},
  {name: "Somalia", code: "so"},
  {name: "Sri Lanka", code: "lk"},
  {name: "Suazilandia", code: "sz"},
  {name: "Sudáfrica", code: "za"},
  {name: "Sudán", code: "sd"},
  {name: "Sudán del Sur", code: "ss"},
  {name: "Suecia", code: "se"},
  {name: "Suiza", code: "ch"},
  {name: "Surinam", code: "sr"},
  {name: "Tailandia", code: "th"},
  {name: "Tanzania", code: "tz"},
  {name: "Tayikistán", code: "tj"},
  {name: "Timor Oriental", code: "tl"},
  {name: "Togo", code: "tg"},
  {name: "Tokelau", code: "tk"},
  {name: "Tonga", code: "to"},
  {name: "Trinidad y Tobago", code: "tt"},
  {name: "Túnez", code: "tn"},
  {name: "Turkmenistán", code: "tm"},
  {name: "Turquía", code: "tr"},
  {name: "Tuvalu", code: "tv"},
  {name: "Ucrania", code: "ua"},
  {name: "Uganda", code: "ug"},
  {name: "Uruguay", code: "uy"},
  {name: "Uzbekistán", code: "uz"},
  {name: "Vanuatu", code: "vu"},
  {name: "Venezuela", code: "ve"},
  {name: "Vietnam", code: "vn"},
  {name: "Wallis y Futuna", code: "wf"},
  {name: "Yemen", code: "ye"},
  {name: "Yibuti", code: "dj"},
  {name: "Zambia", code: "zm"},
  {name: "Zimbabue", code: "zw"}
]
